// TODO: repair typing
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck

import React from 'react';
import { useSelector } from 'react-redux';
import { UserRole } from 'core';
import { isEmpty } from 'ramda';
import { ProfilesSelectors } from '../../../common/config/store';
import StyledTable from '../../organisms/styled-table';
import ListModifier from '../../organisms/list-modifier';
import { FormValues } from '../form-search-user';
import { useIntl } from '../../../common/config/i18n';
import { Empty } from 'antd';
import { UserInfo } from 'types';

type Props = {
  onClickEdit?: (record: object) => void;
  onClickDelete?: (record: object) => void;
  filterValues: FormValues;
  canWrite: boolean;
};

const filterByString = (filteredBy: string) => (fieldName: 'firstName' | 'lastName') => (user: UserInfo) => {
  const re = new RegExp(filteredBy, 'i');
  return user[fieldName] ? re.exec(user[fieldName]) : false;
};

const ProfilList: React.FC<Props> = ({ onClickDelete, onClickEdit, filterValues, canWrite }: Props) => {
  const { t } = useIntl();
  const mappingSections = (record: object, sectionName: string) => {
    if (
      record.sections?.filter((section) => section.name === sectionName)[0]?.read &&
      record.sections?.filter((section) => section.name === sectionName)[0]?.write
    ) {
      return <div>{record.sections?.filter((section) => section.name === sectionName)[0]?.writeLabel}</div>;
    }
    if (
      !record.sections?.filter((section) => section.name === sectionName)[0]?.read &&
      !record.sections?.filter((section) => section.name === sectionName)[0]?.write
    ) {
      return <div>-</div>;
    }
    if (
      record.sections?.filter((section) => section.name === sectionName)[0]?.read &&
      !record.sections?.filter((section) => section.name === sectionName)[0]?.write
    ) {
      return <div>{record.sections?.filter((section) => section.name === sectionName)[0]?.readLabel}</div>;
    }
    if (
      !record.sections?.filter((section) => section.name === sectionName)[0]?.read &&
      record.sections?.filter((section) => section.name === sectionName)[0]?.write
    )
      return <div>{record.sections?.filter((section) => section.name === sectionName)[0]?.writeLabel}</div>;
  };
  const mappingSectionUsers = (record: object, sectionName: string) => {
    if (
      !record.sections?.filter((section) => section.name === sectionName)[0]?.read &&
      !record.sections?.filter((section) => section.name === sectionName)[0]?.write
    ) {
      return <div>{t('form', 'UNIQUE')}</div>;
    }
    if (
      !record.sections?.filter((section) => section.name === sectionName)[0]?.read &&
      record.sections?.filter((section) => section.name === sectionName)[0]?.write
    ) {
      return <div>{t('form', 'UNIQUE')}</div>;
    }
    if (
      record.sections?.filter((section) => section.name === sectionName)[0]?.read &&
      !record.sections?.filter((section) => section.name === sectionName)[0]?.write
    ) {
      return <div>{t('form', 'READ_ONLY')}</div>;
    }
    return <div>{record.sections?.filter((section) => section.name === sectionName)[0]?.readLabel}</div>;
  };
  let data: UserInfo[] = useSelector(ProfilesSelectors.profilesSelector);
  if (!isEmpty(filterValues)) {
    if (filterValues.firstName) {
      const filterByFirstName = filterByString(filterValues.firstName)('firstName');
      data = data.filter(filterByFirstName);
    }
    if (filterValues.lastName) {
      const filterByLastName = filterByString(filterValues.lastName)('lastName');
      data = data.filter(filterByLastName);
    }
    if (!isEmpty(filterValues.roles)) {
      data = data.filter((user: UserInfo) => {
        if (filterValues.roles) {
          const result = filterValues.roles.map((role: string | undefined) => {
            return user.userRoles && role
              ? Boolean(user.userRoles.find((userRole: UserRole) => userRole.role.name === role))
              : false;
          });
          return Boolean(result.find((b) => b === true));
        }
        return false;
      });
    }
  }

  const columns = [
    {
      title: t('table', 'COLUMN_USER_PROFILE'),
      dataIndex: 'name',
      key: 'name',
    },
    {
      title: t('table', 'COLUMN_CIRCULATION'),
      key: 'circulation',
      children: [
        {
          title: t('table', 'COLUMN_VUE'),
          render: (record: object) => {
            return mappingSections(record, 'Circulations');
          },
          key: 'vue',
        },
      ],
    },
    {
      title: t('table', 'COLUMN_HISTOTISATION'),
      key: 'historisation',
      children: [
        {
          title: t('table', 'COLUMN_VUE'),
          key: 'vue',
          render: (record: object) => {
            return mappingSections(record, 'Historisation');
          },
        },
      ],
    },
    {
      title: t('table', 'COLUMN_FLUX_CLIENT'),
      dataIndex: 'flux',
      key: 'flux',
      children: [
        {
          title: t('table', 'COLUMN_VUE'),
          render: (record: object) => {
            return mappingSections(record, 'Customer-Flux');
          },
          key: 'vue',
        },
      ],
    },
    {
      title: t('table', 'COLUMN_FONCTIONNALITES'),
      dataIndex: 'fonctionallités',
      key: 'fonctionallités',
      children: [
        {
          title: t('table', 'COLUMN_ENVOI_COMM'),
          render: (record: object) => {
            return mappingSections(record, 'Communication');
          },
          key: 'envoi',
        },
        {
          title: t('table', 'COLUMN_ENVOI_DIFF'),
          render: (record: object) => {
            return mappingSections(record, 'Deffered-Communications');
          },
          key: 'masse',
        },
      ],
    },
    {
      title: t('table', 'COLUMN_REF'),
      dataIndex: 'Administration > Référentiels ',
      key: 'Administration > Référentiels ',
      children: [
        {
          title: t('table', 'COLUMN_MOTIFS'),
          key: 'Motifs',
          render: (record: object) => {
            return mappingSections(record, 'Reasons');
          },
        },
        {
          title: t('table', 'COLUMN_AIDES_INFO'),
          render: (record: object) => {
            return mappingSections(record, 'Help-Info');
          },
          key: 'masse',
        },
        {
          title: t('table', 'COLUMN_TYPO'),
          render: (record: object) => {
            return mappingSections(record, 'Typologies');
          },
          key: 'typo',
        },
        {
          title: t('table', 'COLUMN_SITUATION'),
          render: (record: object) => {
            return mappingSections(record, 'Situations');
          },
          key: 'situation',
        },
      ],
    },
    {
      title: t('table', 'COLUMN_ADMIN'),
      dataIndex: 'Administration > Référentiels ',
      key: 'Administration > Référentiels ',
      children: [
        {
          title: t('table', 'COLUMN_PROFIL'),
          render: (record: object) => {
            return mappingSections(record, 'Profiles');
          },
          key: 'profils',
        },
        {
          title: t('table', 'COLUMN_USERS'),
          render: (record: object) => {
            return mappingSectionUsers(record, 'Users');
          },
          key: 'users',
        },
      ],
    },
    {
      key: 'modifier',
      title: t('table', 'COLUMN_EDIT_DELETE'),
      shouldBeAdmin: true,
      render: (record: UserInfo) => {
        return (
          <ListModifier
            hideDeleteButton={!canWrite}
            onEdit={() => onClickEdit(record)}
            onDelete={() => onClickDelete(record)}
          />
        );
      },
    },
  ];
  return (
    <StyledTable
      className="table-striped-rows"
      pagination={false}
      dataSource={data}
      columns={canWrite ? columns : columns.filter((column) => !column.shouldBeAdmin)}
      rowKey="id"
      locale={{ emptyText: <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} description={t('empty')} /> }}
    />
  );
};

export default ProfilList;
